import store from '../app/store';

export const GATEWAY_TOKEN_KEY = 'gateway_token';

export function getGatewayToken() {
  const keycloakGatewayToken = sessionStorage.getItem(GATEWAY_TOKEN_KEY);
  if (keycloakGatewayToken) return keycloakGatewayToken;
  const state = store.getState();
  return (
    (state.account && state.account.access_token) ||
    (state.agentReducer && state.agentReducer.paymentToken) ||
    ''
  );
}

export function setGatewayToken(token) {
  if (token) {
    sessionStorage.setItem(GATEWAY_TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(GATEWAY_TOKEN_KEY);
  }
}

export function clearGatewayToken() {
  sessionStorage.removeItem(GATEWAY_TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./src/libs/getGatewayToken.js